let GLADLY_APP_ID = "";
let ENV = "STAGING";
export const COOKIE_NAME = "gladlySession";
export function configureGladly(opts) {
    GLADLY_APP_ID = opts.appId;
    ENV = opts.env === "prod" ? "PROD" : "STAGING";
}
export function getAppId() {
    return GLADLY_APP_ID;
}
export function getEnv() {
    return ENV;
}
